import React from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import Radium from 'radium';
import { Close } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { UTLabel } from '@widergy/energy-ui';

import { actionCreators as deviceActions } from 'redux/deviceHandlers';
import { appConfig } from 'config/customization';
import Images from 'config/assets';
import { message } from 'utils/stringUtils';

import styles from './styles';

const AppDownloader = ({ handleClose }) => (
  <div style={styles.container}>
    <div style={styles.header}>
      <IconButton style={styles.closeButton} onClick={handleClose}>
        <Close />
      </IconButton>
    </div>
    <div style={styles.content}>
      <div style={styles.logoAndText}>
        <div style={styles.logo}>
          <img alt="logo" src={Images.authFormWrapper} style={styles.imageLogo} />
        </div>
        <div style={styles.firstLine}>
          <UTLabel white style={styles.iconTitleSize}>
            {message('AppDownloader:downloadAppMobile1')}
          </UTLabel>
          <div style={styles.textBackgroundContainer}>
            <UTLabel white iconTitle extrabold style={styles.textWithBackground}>
              {message('AppDownloader:downloadAppMobile2').toUpperCase()}
            </UTLabel>
            <UTLabel iconTitle style={styles.textWithBackground}>
              {message('AppDownloader:downloadAppMobile3')}
            </UTLabel>
          </div>
        </div>
        <div style={styles.secondLine}>
          <UTLabel white style={styles.iconTitleSize}>
            {message('AppDownloader:downloadAppMobile4').toUpperCase()}
          </UTLabel>
          <UTLabel white iconTitle extrabold style={styles.textSpace}>
            {message('AppDownloader:downloadAppMobile5').toUpperCase()}
          </UTLabel>
          <UTLabel white style={styles.iconTitleSize}>
            {message('AppDownloader:downloadAppMobile6').toUpperCase()}
          </UTLabel>
        </div>
      </div>
      <div style={styles.storesAndMobile}>
        <div style={styles.buttonsContainer}>
          <a href={appConfig.googlePlayStoreURL}>
            <img alt="Google Play" src={Images.appDownloaderGoogleplay} style={styles.buttonImage} />
          </a>
          <a href={appConfig.appleStoreURL}>
            <img alt="App Store" src={Images.appDownloaderAppstore} style={styles.buttonImage} />
          </a>
        </div>
        <img
          alt={message('AppDownloader:device')}
          src={Images.appDownloaderPhone}
          style={styles.mobileImage}
        />
      </div>
    </div>
  </div>
);

AppDownloader.propTypes = {
  handleClose: func.isRequired
};

const mapDispatchToProps = dispatch => ({
  handleClose: () => dispatch(deviceActions.submitAdvice())
});

export default connect(null, mapDispatchToProps)(Radium(AppDownloader));
